import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PromoTypeItem } from "./types";

export interface PromotionCalendarState {
  promoTypeList: PromoTypeItem[];
  timeUnit: string;
  sortBy: string;
  textIndicates: string;
  seller_id: string;
  records: number;
}

export const initialState: PromotionCalendarState = {
  promoTypeList: [
    {
      id: 0,
      field: "7_DAY_DEAL",
      name: "7 Day Deal",
      color: "#C8E6C9",
      checked: true,
    },
    {
      id: 1,
      checked: true,
      field: "COUPON",
      name: "Coupon",
      color: "#E1BEE7",
    },
    {
      id: 2,
      checked: true,
      field: "LIGHTNING_DEAL",
      name: "Lightning Deal",
      color: "#FFCCBC",
    },
    {
      id: 3,
      checked: true,
      field: "PRIME_EXCLUSIVE_DEAL",
      name: "Prime Exclusive Deal",
      color: "#BBDEFB",
    },
    {
      id: 4,
      checked: true,
      field: "PROMOTION_CODE",
      name: "Promotion Code",
      color: "#B2DFDB",
    },
  ],
  timeUnit: "week",
  sortBy: "forecasting",
  textIndicates: "incrementalForecastedSales",
  seller_id: "",
  records: 0,
};

export const promotionCalendarSlice = createSlice({
  name: "promotionCalendar",
  initialState,
  reducers: {
    updatePromoTypeList: (
      state: PromotionCalendarState,
      action: PayloadAction<PromoTypeItem[]>
    ) => {
      state.promoTypeList = action.payload;
    },
    updateTimeUnitFilter: (
      state: PromotionCalendarState,
      action: PayloadAction<string>
    ) => {
      state.timeUnit = action.payload;
    },
    updateSortByFilter: (
      state: PromotionCalendarState,
      action: PayloadAction<string>
    ) => {
      state.sortBy = action.payload;
    },
    updateTextIndicatesFilter: (
      state: PromotionCalendarState,
      action: PayloadAction<string>
    ) => {
      state.textIndicates = action.payload;
    },
    updateSellerId: (
      state: PromotionCalendarState,
      action: PayloadAction<string>
    ) => {
      state.seller_id = action.payload;
    },
    addRecords: (
      state: PromotionCalendarState,
      action: PayloadAction<number>
    ) => {
      state.records = action.payload;
    },
  },
});

export const {
  updatePromoTypeList,
  updateTimeUnitFilter,
  updateSortByFilter,
  updateTextIndicatesFilter,
  updateSellerId,
  addRecords,
} = promotionCalendarSlice.actions;
